import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../contexts/Auth.context';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { authenticatedUser: user } = useAuth()

    return <Route {...rest} render={props => (
        user?.email ? <Component {...props} /> : (
            <Redirect to={{
                pathname: '/login',
                state: { from: props.location }
            }}
            />
        )
    )} />
}

export default PrivateRoute;